module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/nagoya_point3_3-fd6c2930847cee0e9aa83a68aa638aa9.jpg";